import { useSeo } from '@/hooks/useSeo';
import HeroCarousel from './components/HeroCarousel';
import DramaIntro from './components/DramaIntro';
import LatestUpdates from './components/LatestUpdates';
import HotDramas from './components/HotDramas';
import CollectionsSection from './components/CollectionsSection';
import RecentHistory from './components/RecentHistory';

const TITLE = '迷人的保姆在线观看 - 高清电视剧在线播放平台';
const DESCRIPTION =
  '迷人的保姆在线观看为您提供最新电视剧在线播放服务，涵盖剧情介绍、剧集同步更新，方便您随时观看和了解剧情动态。';
const KEYWORDS = '迷人的保姆在线观看,迷人的保姆电视剧,迷人的保姆剧情,电视剧在线观看,高清电视剧,影视在线播放';

export default function Home() {
  useSeo({ title: TITLE, description: DESCRIPTION, keywords: KEYWORDS });

  return (
    <div className="w-full">
      <h1 className="sr-only">迷人的保姆在线观看 - 高清电视剧在线播放平台</h1>
      <HeroCarousel />
      <DramaIntro />
      <LatestUpdates />
      <HotDramas />
      <CollectionsSection />
      <RecentHistory />
    </div>
  );
}